import * as platform from 'platform'
import {ObjectUtils} from '@colonist/utils'

interface UserMachine {
    browserName: string | undefined
    browserVersion: string | undefined
    osName: string | undefined
}

const knownBots: UserMachine[] = [
    // Weird behavior in Google Analytics coming from a user with these attributes
    // https://user-images.githubusercontent.com/6215305/125231510-790e6a80-e30d-11eb-88ae-9546733c16c2.png
    // https://cdn.discordapp.com/attachments/710554327428890716/860496911081013268/unknown.png
    {
        browserName: 'Chrome',
        browserVersion: '15.0.87',
        osName: 'Linux',
    },
]

function getUserMachineDetails(): UserMachine {
    return {
        browserName: platform.name,
        browserVersion: platform.version,
        osName: platform.os?.family,
    }
}

export function isCrawler(): boolean {
    const userMachine = getUserMachineDetails()
    for(const bot of knownBots) {
        if(ObjectUtils.isObjectEqual(bot, userMachine)) return true
    }
    return false
}
